export default function(action) {
    const titles = {
        approve: 'согласование',
        sign: 'подписание',
        rework: 'доработку',
    }
    if (action in titles) {
        return titles[action];
    }
    return action;
}
